const AuditLog = () => {

    return (
        <div className="shopping-cart">
            <h1>THIS IS THE AUDIT LOG PAGE</h1>

        
        </div>
    )
}

export default AuditLog